import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useCallback, useEffect, useState } from 'react';
import Button from '../Button';
import Card from '../Card';
import Collapse from '../Collapse';
var drawerToggles = {};

function Toggle(_ref) {
  var drawerId = _ref.drawerId,
      restProps = _objectWithoutPropertiesLoose(_ref, ["drawerId"]);

  var handleClick = useCallback(function (event) {
    var drawerToggle = drawerToggles[drawerId];

    if (drawerToggle) {
      event.preventDefault();
      drawerToggle();
    }
  }, [drawerId]);
  return jsx(Button, _extends({
    icon: {
      name: 'info'
    },
    tooltip: {
      title: 'More info'
    },
    size: "xs",
    theme: false,
    color: "foregroundSecondary",
    hover: {
      backgroundColor: 'highlight'
    },
    onClick: handleClick,
    "data-helper-drawer-toggle": true
  }, restProps));
}

function HelperDrawer(_ref2) {
  var children = _ref2.children,
      id = _ref2.id,
      restProps = _objectWithoutPropertiesLoose(_ref2, ["children", "id"]);

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  useEffect(function () {
    drawerToggles[id] = function () {
      return setOpen(function (open) {
        return !open;
      });
    };

    return function () {
      delete drawerToggles[id];
    };
  }, [id]);
  return jsx(Collapse, {
    open: open,
    lazy: true,
    css: {
      width: '100%'
    }
  }, jsx(Card, _extends({
    subdued: true,
    padding: 1,
    fontSize: 4
  }, restProps), children));
}

HelperDrawer.Toggle = Toggle;
export default HelperDrawer;